import React from 'react';
import { ZapIcon, AwardIcon, ShieldIcon, WalletIcon } from 'lucide-react';
export function BenefitCards() {
  const benefits = [{
    title: 'מהירות תגובה',
    desc: 'מגיעים תוך שעה מהשיחה, עובדים 24/7 כולל שבתות וחגים למקרי חירום.',
    icon: ZapIcon
  }, {
    title: 'מקצועיות ללא פשרות',
    desc: '15 שנות ניסיון, צוות מוסמך ומיומן עם הציוד המתקדם ביותר בעולם.',
    icon: AwardIcon
  }, {
    title: 'אחריות מלאה',
    desc: 'אחריות מלאה בכתב על כל עבודה – אם הבעיה חוזרת, אנחנו חוזרים לתקן בחינם.',
    icon: ShieldIcon
  }, {
    title: 'מחיר הוגן ושקוף',
    desc: 'מחירים שקופים ללא הפתעות, הצעת מחיר חינם לפני כל עבודה. עובדים עם הביטוח.',
    icon: WalletIcon
  }];
  return <section className="py-20 bg-white px-4 md:px-8" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-18">
            למה לבחור ביבש-טק פרו?
          </h2>
          <div className="w-24 h-1 bg-[#f97316] mx-auto rounded-full" data-id="element-19"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-20">
          {benefits.map((benefit, index) => <div key={index} className="bg-white border border-gray-100 p-8 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-21">
              <div className="w-14 h-14 bg-orange-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-22">
                <benefit.icon className="w-8 h-8 text-[#f97316]" data-id="element-23" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-25">{benefit.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}